import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Sparkles, Truck, Shield, Package } from 'lucide-react';
import WhyChooseUs from './WhyChooseUs';


import Gallery1 from '@/assets/1.webp';
import Gallery2 from '@/assets/2.webp';
import Gallery3 from '@/assets/3.webp';
import Gallery4 from '@/assets/4.webp';
import Gallery5 from '@/assets/5.webp';


/**
 * AboutPage - high-fidelity, premium About page for "Sunrise" bookstore.
 * Uses the project's Tailwind palette (primary = terracotta, background = ivory).
 *
 * Notes:
 * - Responsive: two-column grid that stacks on mobile.
 * - Typography follows the design system: italic hero, spacious leading.
 * - Accessibility: semantic headings, accessible button labels.
 */

const AboutPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <main className="min-h-screen bg-background text-text font-sans antialiased">
      {/* Hero / Intro */}
      <section
        aria-labelledby="about-hero-title"
        className="relative overflow-hidden bg-background"
     
      >
        <div className="container-custom max-w-7xl mx-auto px-4 py-[80px] lg:py-[120px]">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left: Images cluster */}
            <div className="order-2 lg:order-1 flex justify-center items-center">
              <div className="flex items-center -mx-3 sm:-mx-4">
                <div className="w-full px-3 sm:px-4 xl:w-1/2">
                  <div className="py-3 sm:py-4">
                    <img
                      src={Gallery1}
                      alt=""
                      className="w-full rounded-2xl"
                    />
                  </div>
                  <div className="py-3 sm:py-4">
                    <img
                      src={Gallery2}
                      alt=""
                      className="w-full rounded-2xl"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:px-4 xl:w-1/2">
                  <div className="relative z-10 my-4">
                    <img
                      src={Gallery3}
                      alt=""
                      className="w-full rounded-2xl"
                    />
                    <span className="absolute -right-7 -bottom-7 z-[-1]">
   <svg
                        width={134}
                        height={106}
                        viewBox="0 0 134 106"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="1.66667"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 1.66667 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 16.3333 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 31 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 45.6667 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3334"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 60.3334 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 88.6667 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 117.667 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 74.6667 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 103 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy={104}
                          r="1.66667"
                          transform="rotate(-90 132 104)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="89.3333"
                          r="1.66667"
                          transform="rotate(-90 1.66667 89.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="89.3333"
                          r="1.66667"
                          transform="rotate(-90 16.3333 89.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="89.3333"
                          r="1.66667"
                          transform="rotate(-90 31 89.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="89.3333"
                          r="1.66667"
                          transform="rotate(-90 45.6667 89.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 60.3333 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 88.6667 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 117.667 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 74.6667 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 103 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="89.3338"
                          r="1.66667"
                          transform="rotate(-90 132 89.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="74.6673"
                          r="1.66667"
                          transform="rotate(-90 1.66667 74.6673)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="31.0003"
                          r="1.66667"
                          transform="rotate(-90 1.66667 31.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 16.3333 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="31.0003"
                          r="1.66667"
                          transform="rotate(-90 16.3333 31.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 31 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="31.0003"
                          r="1.66667"
                          transform="rotate(-90 31 31.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 45.6667 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="31.0003"
                          r="1.66667"
                          transform="rotate(-90 45.6667 31.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 60.3333 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 60.3333 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 88.6667 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 88.6667 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 117.667 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 117.667 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 74.6667 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 74.6667 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 103 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 103 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="74.6668"
                          r="1.66667"
                          transform="rotate(-90 132 74.6668)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="30.9998"
                          r="1.66667"
                          transform="rotate(-90 132 30.9998)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 1.66667 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 1.66667 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 16.3333 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 16.3333 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 31 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 31 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 45.6667 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 45.6667 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 60.3333 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 60.3333 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 88.6667 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 88.6667 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 117.667 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 117.667 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 74.6667 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 74.6667 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 103 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 103 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="60.0003"
                          r="1.66667"
                          transform="rotate(-90 132 60.0003)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="16.3333"
                          r="1.66667"
                          transform="rotate(-90 132 16.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="45.3333"
                          r="1.66667"
                          transform="rotate(-90 1.66667 45.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="1.66667"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 1.66667 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="45.3333"
                          r="1.66667"
                          transform="rotate(-90 16.3333 45.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="16.3333"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 16.3333 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="45.3333"
                          r="1.66667"
                          transform="rotate(-90 31 45.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={31}
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 31 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="45.3333"
                          r="1.66667"
                          transform="rotate(-90 45.6667 45.3333)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="45.6667"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 45.6667 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 60.3333 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="60.3333"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 60.3333 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 88.6667 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="88.6667"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 88.6667 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 117.667 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="117.667"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 117.667 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 74.6667 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx="74.6667"
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 74.6667 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 103 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={103}
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 103 1.66683)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="45.3338"
                          r="1.66667"
                          transform="rotate(-90 132 45.3338)"
                          fill="#A8523A"
                        />
                        <circle
                          cx={132}
                          cy="1.66683"
                          r="1.66667"
                          transform="rotate(-90 132 1.66683)"
                          fill="#A8523A"
                        />
                        
                      </svg>
                        
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 lg:order-2">
              <span className="inline-block text-sm font-medium text-primary-600 mb-4">
                About Sunrise
              </span>

              <h1
                id="about-hero-title"
                className="mb-6 text-4xl lg:text-[48px] font-heading italic text-primary DEFAULT leading-tight"
                style={{ letterSpacing: '0.01em' }}
              >
                A quiet place for discovery — books that feel like home.
              </h1>

              <p className="mb-6 text-base text-text-secondary max-w-prose">
                Sunrise is an independent bookstore and quiet refuge where careful curation, slow
                reading and warm service meet. Since opening our doors we’ve sought to preserve the
                intimate, tactile pleasures of books — the soft grain of paper, the smell of cloth
                bindings, and the unexpected conversation at the counter.
              </p>

              <p className="mb-8 text-base text-text-secondary max-w-prose">
                We balance the old and the new: thoughtful classics, contemporary voices, and
                stationery crafted for writing by hand. Each title is chosen with care — to
                surprise, to steady, and to accompany our neighbours through everyday life.
              </p>

              <div className="flex flex-wrap gap-4 items-center">
                <Link
                  to="/products"
                  aria-label="Browse Sunrise bookshop catalog"
                  className="inline-flex items-center gap-3 px-6 py-3 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-dark transition-transform transform-gpu hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-light"
                >
                  Browse Books
                </Link>

                <Link
                  to="/visit"
                  aria-label="Learn about visiting Sunrise"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-primary-light bg-background-muted text-primary-700 hover:bg-primary-50 transition-colors focus:outline-none"
                >
                  Visit Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values + Stats */}
      <section className="py-20">
        <div className="container-custom mx-auto px-4 max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-semibold text-primary DEFAULT mb-4">Our mission</h2>
              <p className="text-text-secondary mb-6">
                To keep a small, generous space in the city where readers can slow down, discover
                unusual books and connect with other people who love reading. We prize thoughtful
                selection, careful service and a commitment to community.
              </p>

              <ul className="space-y-4">
                <li className="flex gap-4 items-start">
                  <span className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
                    <Sparkles className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="font-medium text-primary DEFAULT">Curated with care</p>
                    <p className="text-text-secondary text-sm">
                      Every book on our shelves is chosen for its voice and quality.
                    </p>
                  </div>
                </li>

                <li className="flex gap-4 items-start">
                  <span className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
                    <Truck className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="font-medium text-primary DEFAULT">Thoughtful service</p>
                    <p className="text-text-secondary text-sm">
                      Careful packaging, reliable delivery and helpful recommendations.
                    </p>
                  </div>
                </li>

                <li className="flex gap-4 items-start">
                  <span className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
                    <Shield className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="font-medium text-primary DEFAULT">A warm, safe space</p>
                    <p className="text-text-secondary text-sm">
                      We host readings, small events and quiet browsing hours for all ages.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-background-soft rounded-3xl p-8 border border-border">
              <div className="grid grid-cols-2 gap-6">
                <Stat label="Years on Main" value="12+" />
                <Stat label="Titles curated" value="8,400+" />
                <Stat label="Community events" value="120+" />
                <Stat label="Happy readers" value="4,200+" />
              </div>

              <p className="mt-6 text-sm text-text-secondary">
                We reinvest a portion of every purchase into local literacy programs and author
                events — because books are best when they bring people together.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Combined Visual / Story Section (from second snippet) */}
      <section className="py-24 relative bg-background">
        <div className="container-custom max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="grid grid-cols-2 gap-6 order-2 lg:order-1">
              <div className="pt-16">
                <img
                  src={Gallery4}
                  alt="Books and light"
                  className="rounded-2xl w-full object-cover border border-border"
                />
              </div>
              <img
                src={Gallery5}
                alt="Book closeup"
                className="rounded-2xl w-full object-cover border border-border"
              />
            </div>

            <div className="order-1 lg:order-2 flex flex-col items-start">
              <h3 className="text-3xl font-bold text-primary DEFAULT leading-tight mb-4">
                Empowering readers, one title at a time
              </h3>
              <p className="text-text-secondary mb-6">
                Our work is collaborative: with suppliers, authors and our community. Each season's
                list is the result of conversations, discoveries and recommendations. That care
                shows in every title we place on the shelf.
              </p>

              <div className="flex flex-wrap gap-8 mb-8">
                <StatLarge label="33+" sub="Years of collective experience"   />
                <StatLarge label="125+" sub="Local events & collaborations" />
                <StatLarge label="52+" sub="Community partners" />
              </div>

              {/* <Link
                to="/about/more"
                className="inline-flex items-center gap-3 px-5 py-3 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-dark transition-colors"
                aria-label="Read more about Sunrise"
              >
                Read More
              </Link> */}
            </div>
          </div>
        </div>
      </section>

      {/* Footer features */}
      <WhyChooseUs
        cards={[
          {
            icon: <BookOpen width="30" height="30" stroke="#A8523A" strokeWidth="2" />,
            title: 'Vast Collection',
            description: 'From classics to modern favorites — everything under one roof.',
          },
          {
            icon: <Truck width="30" height="30" stroke="#A8523A" strokeWidth="2" />,
            title: 'Fast Shipping',
            description: 'Delivered to your doorstep quickly and safely.',
          },
          {
            icon: <Package width="30" height="30" stroke="#A8523A" strokeWidth="2" />,
            title: 'Fast Customer Service',
            description: '24/7 support and hassle-free returns make us your go-to store.',
          },
          {
            icon: <Shield width="30" height="30" stroke="#A8523A" strokeWidth="2" />,
            title: 'Quick Transaction',
            description: 'Secure and swift payment processing for a seamless shopping experience.',
          },
        ]}
      />
    </main>
  );
};

export default AboutPage;

/* ---------- Helper subcomponents (kept in same file for quick drop-in) ---------- */

const Stat: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="bg-white rounded-xl p-4 flex flex-col items-start justify-center border border-border">
    <div className="text-xl font-semibold text-primary-800 DEFAULT">{value}</div>
    <div className="text-sm text-text-secondary mt-1">{label}</div>
  </div>
);

const StatLarge: React.FC<{ label: string; sub?: string }> = ({ label, sub }) => (
  <div className="flex flex-col items-start">
    <div className="text-4xl font-bold text-primary-800 DEFAULT leading-none">{label}</div>
    {sub && <div className="text-sm text-text-secondary mt-1">{sub}</div>}
  </div>
);

const Feature: React.FC<{ icon: React.ReactNode; title: string; subtitle?: string }> = ({
  icon,
  title,
  subtitle,
}) => (
  <div className="flex items-start gap-4 bg-background-soft rounded-2xl p-4 border border-border">
    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
      {icon}
    </div>
    <div>
      <div className="font-medium text-text DEFAULT">{title}</div>
      {subtitle && <div className="text-sm text-text-secondary">{subtitle}</div>}
    </div>
  </div>
);
